const SIZE_SMALL = 'small'
const SIZE_MEDIUM = 'medium'

export const ICON_SIZES = {
  [SIZE_MEDIUM]: 24,
  [SIZE_SMALL]: 19,
} as const

export const LOCK_ICON_SIZES = {
  [SIZE_MEDIUM]: 20,
  [SIZE_SMALL]: 16,
} as const

export type ButtonSize = keyof typeof ICON_SIZES
